import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { CancelAutoRenewAutouploadModalProps } from './CancelAutoRenewAutouploadModal.types';

export const renderCancelAutoRenewAutouploadModal = (data?: CancelAutoRenewAutouploadModalProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_AUTOUPLOAD, data });

export const closeCancelAutoRenewAutouploadModal = () => closePopupHelper(popupNames.SUBSCRIPTION_CANCEL_AUTOUPLOAD);
